<template>
  <div class="ui-select" :class="[disabled ? 'disabled' : '']">
    <div @click="showSelect">
      <p v-if="placeholder && !selectValue" class="ui-select__placeholder">
        {{ placeholder }}
      </p>
      <p v-if="selectValue" class="ui-select__value">
        {{ selectValue | selectFilter(options) }}
      </p>
      <span class="ui-select__icon-wrap">
        <icon class="ui-select__icon" :src="iconUrl"></icon>
      </span>
    </div>
    <section v-if="isPc"
             v-show="showModal"
             class="ui-select__select-list-inner">
      <div v-for="(option, i) in options"
           :key="i"
           class="ui-select__select-item"
           @click="handleSelected(option)">
        {{ option.label }}
      </div>
    </section>
    <van-popup v-else
               v-model="showModal"
               position="bottom"
               :close-on-click-overlay="false">
      <div class="ui-select__select-content">
        <div v-for="(option, i) in options"
             :key="i"
             class="ui-select__select-item"
             @click="handleSelected(option)">
          {{ option.label }}
        </div>
      </div>
      <nio-button type="btn_outline_l"
                  class="ui-select__cancel-btn"
                  @click="showModal = false">
        {{ $t('content.commonCancelText') }}
      </nio-button>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {Popup} from 'vant';
import Icon from './Icon';
import NioButton from './NioButton';

Vue.use(Popup);

const imageIcon = require('@/assets/images/icon/icon_arrows_16.png');

export default {
  name: 'NioSelect',
  components: {
    Icon,
    NioButton
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      selectValue: this.value,
      showModal: false,
      clientWidth: 0
    };
  },
  watch: {
    value(newVal){
      this.selectValue = newVal;
    },
    selectValue(newVal){
      this.$emit('input', newVal);
    }
  },
  computed: {
    iconUrl(){
      return imageIcon;
    },
    isPc() {
      return this.clientWidth > 1023;
    }
  },
  mounted(){
    this.clientWidth = window.innerWidth || document.body.clientWidth;
  },
  methods: {
    showSelect(){
      this.showModal = !this.showModal;
    },
    handleSelected(option){
      this.showModal = false;
      this.selectValue = option.id || option.value || '';
    }
  },
  filters: {
    selectFilter(value, options){
      const item = options.find(opt => opt.id === value || opt.value === value);

      return item ? item.label : '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";
@import "../../assets/scss/mixins";

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.ui-select {
  min-height: sizeTrans(30);
  padding-bottom: sizeTrans($space_10);
  padding-right: sizeTrans($space_20);
  position: relative;
  border-bottom: 1px solid $color_mb3_front;
  color: $color_mb1_front;
  @include font_text_m();
  cursor: pointer;

  &.disabled {
    pointer-events: none;
  }

  &__placeholder {
    color: $color_mb3_front;
  }

  &__icon-wrap {
    position: absolute;
    display: inline-block;
    right: sizeTrans(-$space_10);
    bottom: 0;
    padding: sizeTrans($space_10);
  }

  &__icon {
    width: sizeTrans(15);
    height: sizeTrans(15);
    border-radius: 50%;
  }

  &__select-content {
    @include pagePadding();
  }

  &__select-item {
    height: sizeTrans(60);
    line-height: sizeTrans(60);
    font-size: sizeTrans(16);
    color: $color_mb1_front;
    text-align: center;
    @include ellipsis();
    &:hover {
      background-color: $color_bs3_back;
    }
  }

  &__cancel-btn {
    margin: sizeTrans($space_15) sizeTrans($space_20) sizeTrans(50);
  }

  &__select-list-inner {
    position: absolute;
    width: 100%;
    left: 0;
    top: sizeTrans(30);
    background-color: #FFFFFF;
    z-index: 10;
    border: 1px solid $color_mb3_front;
    border-top: none;
    animation-name: fadeIn;
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: initial;
  }
}
</style>